var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.org)?_c('v-content',[_c('v-card',[_c('v-card-title',[_vm._v("\n            "+_vm._s(_vm.org.info.fullname)+" Profiles\n        ")])],1),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }